import SEO from "components/seo"
import useTranslations from "hooks/useTranslations"
import ParentInfoHero from "./Hero"
import ParentInfoFeatures from "./Features"
import ParentInfoCulture from "./Culture"
import ParentInfoTogether from "./Together"
import ParentInfoFaq from "./Faq"
import ParentInfoBlog from "./Blog"
import ParentInfoContact from "./Contact"

/**
 * Parent information page for UK schools, served at /schools/parent-info on
 * the global build only (skipped for fi and se in gatsby-node.js). DEV-803.
 *
 * Grounds alternate so no two adjacent bands match: mint, white, black, mint,
 * white, black, white.
 */
export default function ParentInfoPage() {
  const { parentInfoSeoTitle } = useTranslations()

  return (
    <div>
      <SEO title={parentInfoSeoTitle} />
      <ParentInfoHero />
      <ParentInfoFeatures />
      <ParentInfoCulture />
      <ParentInfoTogether />
      <ParentInfoFaq />
      <ParentInfoBlog />
      <ParentInfoContact />
    </div>
  )
}
